/**
 * /money — retired (Pass 4: "/money finally stops being a second Recurring").
 * Every definition it used to hold now lives in Manage · Recurring — nothing
 * lost, grouped by kind, with each row's cadence visible. This interstitial
 * explains the move, then redirects to /manage?tab=Recurring. (A true HTTP 301
 * for the route can be added at nginx if wanted; this is the in-app redirect.)
 *
 * Author: Maré Greyling (Thevertex) <mare.greyling@gmail.com> — https://mare-greyling.com
 */
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AppNav from '../components/AppNav.jsx';

export default function MoneySetup() {
  const nav = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => nav('/manage?tab=Recurring', { replace: true }), 3000);
    return () => clearTimeout(t);
  }, [nav]);

  return (
    <div className="min-h-full flex flex-col">
      <AppNav />
      <div className="flex-1 grid place-items-center px-6">
        <div className="card max-w-md text-center">
          <div className="text-3xl mb-3">🔁</div>
          <h1 className="text-xl font-bold mb-2">Money setup has moved to Manage · Recurring</h1>
          <p className="text-slate-400 text-sm leading-relaxed">
            Nothing is lost. Every recurring definition you owned now lives in one place —
            grouped by kind, with its cadence visible in every row.
          </p>
          <Link to="/manage?tab=Recurring" className="btn-primary inline-block mt-5">Open Recurring</Link>
          <p className="text-xs text-slate-500 mt-3">Taking you there…</p>
        </div>
      </div>
    </div>
  );
}
